/*
██╗  ██╗ ██████╗ ██╗   ██╗███████╗██████╗ 
██║  ██║██╔═══██╗██║   ██║██╔════╝██╔══██╗
███████║██║   ██║██║   ██║█████╗  ██████╔╝
██╔══██║██║   ██║╚██╗ ██╔╝██╔══╝  ██╔══██╗
██║  ██║╚██████╔╝ ╚████╔╝ ███████╗██║  ██║
╚═╝  ╚═╝ ╚═════╝   ╚═══╝  ╚══════╝╚═╝  ╚═╝
*/

$(document).on({
	mouseenter : function(){
		var $this = $(this);
		var $c = $this.find('.c');
		$c.each(function(index, el) {
			TweenLite.to(el, 0.3, {
				opacity : 0,
				y     : '-50%',
				delay : index * 0.01,
				ease: Power2.easeInOut,
				onComplete : function(){
					TweenLite.set( this.target, {
						opacity : 0,
						y : '50%',
					});
					TweenLite.to( this.target , 0.4, {
						opacity : 1,
						y : '0%',
						ease: Power2.easeOut,
					});
				}
			});
		});
	}
},'.js-h');




/*
███╗   ██╗ █████╗ ██╗   ██╗██╗ ██████╗  █████╗ ████████╗██╗ ██████╗ ███╗   ██╗
████╗  ██║██╔══██╗██║   ██║██║██╔════╝ ██╔══██╗╚══██╔══╝██║██╔═══██╗████╗  ██║
██╔██╗ ██║███████║██║   ██║██║██║  ███╗███████║   ██║   ██║██║   ██║██╔██╗ ██║
██║╚██╗██║██╔══██║╚██╗ ██╔╝██║██║   ██║██╔══██║   ██║   ██║██║   ██║██║╚██╗██║
██║ ╚████║██║  ██║ ╚████╔╝ ██║╚██████╔╝██║  ██║   ██║   ██║╚██████╔╝██║ ╚████║
╚═╝  ╚═══╝╚═╝  ╚═╝  ╚═══╝  ╚═╝ ╚═════╝ ╚═╝  ╚═╝   ╚═╝   ╚═╝ ╚═════╝ ╚═╝  ╚═══╝
*/

// if( !isMobile.phone ){
// 	$(document).on({
// 		mouseenter : function(e){
// 			var $this = $(this);
// 			var $content = $this.find('.header__dropdown');
// 			if(! $this.is('.is-open')){
// 				$this.addClass('is-open');
// 				TweenLite.set($content, {
// 					opacity:0,
// 					visibility:'hidden'
// 				})
// 				TweenLite.to($content, 0.4, {
// 					opacity:1,
// 					visibility:'visible',
// 					ease : Power2.easeOut
// 				})
// 				return false;
// 			}
// 		},
// 		mouseleave : function(e){
// 			var $this = $(this);
// 			var $content = $this.find('.header__dropdown');
// 			if($this.is('.is-open')){
// 				$this.removeClass('is-open');
// 				TweenLite.to($content, 0.4, {
// 					opacity:0,
// 					visibility:'hidden',
// 					ease : Power2.easeOut
// 				})
// 				return false;
// 			}
// 		}
// 	},'.js-mouseover');

// 	$(document).on({
// 		mouseenter : function(e){
// 			var $this = $(this);
// 			var img = $this.data('collection-handle');
// 			var $i = $('.header__collection-image--'+img+'');

// 			$('.linklist__item').removeClass('is-hover');
// 			$(this).addClass('is-hover');
// 			$('.header__collection-image').removeClass('is-show');
// 			$i.addClass('is-show');
// 		},
// 		mouseleave : function(e){
// 			$('.linklist__item').removeClass('is-hover');
// 			$('.header__collection-image').removeClass('is-show');
// 			$('.header__collection-image--default').addClass('is-show');
// 		}
// 	},'.js-mouseover-image');
// }

$(document).on({
	click : function( e ){
		if( $(this).is('.mobile-nav--close') ){
			if( $('body').is('.header-transparent') ){
				$('body').removeClass('header-transparent')
			}
		}
	}
},'.js-mobile-nav-toggle');



var modal = {
	flags: {
		isOpened: false,
		isAnimating: false
	},
	vars: {
		player: null
	},
	videoOptions: {
		width  : 1280,
		height : 720,
		videoId: null,
		playerVars: {
			'showinfo'    : 1,
			'autohide'    : 1,
			'autoplay'    : 0,
			'controls'    : 1,
			'rel'         : 0,
			'loop'        : 0,
			'playsinline' : 1
		},
		events: {}
	},
	init: function () {
		this.handleEvents();
	},
	handleEvents: function () {
		var _this = this;
		$(document).on('click.modal', '.js-modal-video, #js-modal-video-close', function(evt) {
			var elem = $(this);
			( !_this.flags.isOpened ) ? _this.open(evt, elem) : _this.close(evt, elem);
		});
	},
	removeEvents: function () {
		$(document).off('click.modal');
	},
	appendModal: function () {
		var $body = $('body');
		var appendHtml = 
		'<div id="js-modal-video" class="modal-video">' +
			'<div id="js-modal-video-close" class="modal-video-close-btn">' +
				'<span class="modal-video-close-btn-line line-1"></span>' +
				'<span class="modal-video-close-btn-line line-2"></span>' +
			'</div>' +
			'<div class="modal-video-wrap">' +
				'<div class="modal-video-body">' +
					'<div class="modal-video-ratio">' +
						'<div id="js-modal-video-iframe" class="modal-video-iframe">' +
						'</div>' +
					'</div>' +
				'</div>' +
			'</div>' +
			'<div id="js-modal-video-loader" class="modal-video-loader"></div>' +
		'</div>';
		$body.append(appendHtml);
	},
	removeModal: function () {
		var $body = $('body');
		$body.find('#js-modal-video').remove();
	},
	open: function (evt, elem) {
		var _this = this;
		if ( this.flags.isAnimating ) return;
		this.flags.isAnimating = true;
		this.flags.isOpened = true;
		// Append Modal Html
		this.appendModal();
		// Init YouTube Player
		this.videoOptions.videoId = elem.attr('data-videoid');
		this.videoOptions.events = {
			onReady: function(evt, elem) { _this.onPlayerReady(evt, elem); },
			onStateChange: function(evt, elem) { _this.onPlayerStateChange(evt, elem); }
		};
		this.vars.player = new YT.Player('js-modal-video-iframe', this.videoOptions);

		// Show Modal
		setTimeout(function() {
			TweenLite.set('#js-modal-video-iframe', { autoAlpha: 0 });
			TweenLite.set('#js-modal-video', { display: 'block' });
			TweenLite.fromTo('#js-modal-video', .65,
				{ y: '100%', autoAlpha: 1 },
				{ y: '0%', autoAlpha: 1, ease: Power2.easeInOut, onComplete: function () {
					_this.flags.isAnimating = false;
				}
			});
		}, 1);
	},
	close: function (evt, elem) {
		var _this = this;

		if ( this.flags.isAnimating ) return;
		this.flags.isAnimating = true;
		this.flags.isOpened = false;

		if ( typeof( this.vars.player.pauseVideo ) === 'function' && YT.PlayerState.PLAYING ) this.vars.player.pauseVideo();

		// Hide & Remove Modal
		setTimeout(function() {
			TweenLite.fromTo('#js-modal-video', .45,
				{ y: '0%', autoAlpha: 1 },
				{ y: '100%', autoAlpha: 1, ease: Power2.easeOut, onComplete: function () {
					_this.flags.isAnimating = false;
					_this.removeModal();
				}
			});
		}, 1);
	},
	onPlayerReady: function (evt, elem) {
		$('#js-modal-video').addClass('is-playing');
		TweenLite.to('#js-modal-video-iframe', .25, { autoAlpha: 1, ease: Power1.easeOut });
		TweenLite.to('#js-modal-video-loader', .25, { autoAlpha: 0, onComplete: function () {
			$('#js-modal-video-loader').remove();
		} });
		this.vars.player.playVideo();
	},
	onPlayerStateChange: function (evt, elem) {
		if ( evt.data === YT.PlayerState.ENDED ) {
			this.close(evt, elem);
		}
	}
};


// POLICY
$('.terms-tab-btn').click(function() {
	var index = $('.terms-tab-btn').index(this);
	$('.terms-tab-content').css('display','none');
	$('.terms-tab-content').eq(index).css('display','block');
	$('.terms-tab-btn').removeClass('select');
	$(this).addClass('select')
});

// FAQ
$('.faq__btn').click(function() {
	var detail = $(this).next('.faq__content');
	if (!$(this).is('.is-show')) {
		detail.slideDown(300);
		$(this).addClass('is-show');
	}else{
		detail.slideUp(300);
		$(this).removeClass('is-show');
	}
});


// Register
var popup = {
	isOpen : false,
	onOpen : function(){
		var _this = this;
		$('.popup-register').addClass('is-open');
		_this.isOpen = true;

	},
	onClose : function(){
		var _this = this;
		$('.popup-register').removeClass('is-open');
		_this.isOpen = false;
	}
}

$(document).on({
	click : function( e ){
		e.preventDefault();
		if( !popup.isOpen ){
			popup.onOpen();
		} else {
			popup.onClose();
		}
	}
},'.js-open-popup');

$(document).on({
	click : function( e ){
		e.preventDefault();
		if( popup.isOpen ){
			popup.onClose();
		}
	}
},'.js-close-popup');


// customer fields label fix 
function changeInputSelectLabel(){
	if ($(".template-customers-register").length){
		if ($(".cf-date-field--inline-inputs").length){
			$(".cf-date-field--inline-inputs select").each(function(){
				if($(this).attr("placeholder")=="Year"){$(this).children().first().attr("label","年")}
				else if($(this).attr("placeholder")=="Month"){$(this).children().first().attr("label","月")}
				else if($(this).attr("placeholder")=="Day"){$(this).children().first().attr("label","日")}
			})
		}
		else {
			setTimeout(function(){
				console.log("retry changeInputSelectLabel");
				changeInputSelectLabel();
			}, 200);
		}
	}
}
changeInputSelectLabel()